module.exports = __webpack_public_path__ + "img/feature-10.ad1a3c39.png";